import { Autocomplete, Chip, Skeleton, SxProps, TextField, Theme } from '@mui/material';

import isArray from 'lodash/isArray';
import { FC } from 'react';
import { useGetAllLockersBanksMapQuery } from 'src/redux/api/lockers';

type Props = {
  multiple?: boolean;
  onChange: (ids: number[]) => void;
  sx?: SxProps<Theme>;
  defaultValue?: number;
  error?: string;
  disabled?: boolean;
  selectDefaultIfOneOption?: boolean;
  value?: string | number;
}

const AutocompleteLockersInput: FC<Props> = ({
  multiple,
  sx,
  onChange,
  defaultValue,
  error,
  disabled = false,
  selectDefaultIfOneOption = false,
}) => {
  const { data, isLoading } = useGetAllLockersBanksMapQuery();

  if (isLoading) {
    return <Skeleton height="55px" width="100%" />;
  }

  const itemsArray = Object.values(data || {});

  const options =
    itemsArray.reduce<{ label: string; id: number }[]>((acc, item) => {
      if (item) {
        acc.push({ label: item.name, id: item.id });
      }
      return acc;
    }, []) || [];

  if (!defaultValue && selectDefaultIfOneOption && itemsArray.length === 1 && itemsArray[0].id) {
    onChange([itemsArray[0].id]);
  }

  return (
    <Autocomplete
      options={options}
      fullWidth
      sx={sx}
      multiple={multiple}
      disablePortal
      disabled={disabled}
      onChange={(_, changeValue) => {
        if (isArray(changeValue)) {
          const ids = (changeValue as { label: string; id: number }[]).map(({ id }) => id);
          if (onChange) {
            onChange(ids);
          }
        } else {
          if (onChange) {
            onChange([changeValue?.id]);
          }
        }
      }}
      defaultValue={
        isArray(defaultValue)
          ? defaultValue.reduce((acc, item) => {
              if (item && data?.[item]) {
                const { id, name: groupLabel } = data[item];
                acc.push({ id, label: groupLabel });
              }
              return acc;
            }, [])
          : options.find((option) => option.id === defaultValue)
      }
      renderTags={(valueTag, getTagProps) =>
        (valueTag as { label: string; id: number }[]).map((option, index) => (
          <Chip {...getTagProps({ index })} key={option.id} size="small" label={option.label} variant="soft" />
        ))
      }
      renderInput={(params) => <TextField {...params} label={'Locker Banks'} error={!!error} helperText={error} />}
    />
  );
};

export default AutocompleteLockersInput;
